import { SxProps, Theme } from "@mui/material";
import { TORCH_RED, TORCH_RED_BRIGHT } from "../../../constants";

// Shared by the Admin Flash/KpiUpdate/ReleaseNotes/SeoInsights tabs, which all copy-pasted this
// same button styling via makeStyles (a v4-only API not available on @mui/material v5).
// Sized down from MUI's own "medium" Button default (0.875rem / 6px 16px) - these are dense,
// repeated-per-row tile actions (New/Edit/Delete), not page-level calls to action, so a smaller
// footprint reads better than the default. Not touching .admin_page_tabs (adminShared.scss) -
// that's the Users/Requests/etc. tab switcher strip, a separate concern from these tile buttons.
export const adminActionButtonSx: SxProps<Theme> = {
  backgroundColor: TORCH_RED,
  color: "#FFF !important",
  borderRadius: "0px !important",
  border: "none !important",
  marginRight: "10px",
  fontSize: "0.75rem !important",
  padding: "4px 10px !important",
  "&:hover": {
    backgroundColor: `${TORCH_RED_BRIGHT} !important`,
    border: "none !important",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
  },
};

export const adminActionButtonOutlinedSx: SxProps<Theme> = {
  backgroundColor: "transparent !important",
  color: `${TORCH_RED} !important`,
  borderRadius: "0px !important",
  border: `1px solid ${TORCH_RED} !important`,
  marginRight: "10px",
  fontSize: "0.75rem !important",
  padding: "4px 10px !important",
  "&:hover": {
    backgroundColor: "rgba(244, 2, 42, 0.15) !important",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
  },
  ".theme-dark &": {
    color: "#FFF !important",
  },
};

export const adminButtonsContainerSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
};
